import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class UserImage extends Component {
  static renderImg(picture) {
    if (picture) {
      return <img src={picture} className="opacity-100" alt="presentation" />;
    }

    return <img className="opacity-100" alt="presentation" />;
  }

  render() {
    const { picture, borderStyle, classes, size } = this.props;
    const style = size ? { width: size, height: size, minWidth: size, minHeight: size } : undefined;

    return (
      <div className={`user-image round ${classes} ${borderStyle} ${size ? 'custom-size' : ''}`} style={style}>
        {UserImage.renderImg(picture)}
      </div>
    );
  }
}

UserImage.propTypes = {
  picture: PropTypes.string,
  borderStyle: PropTypes.string,
  classes: PropTypes.string,
  size: PropTypes.number
};
UserImage.defaultProps = {
  borderStyle: '',
  classes: ''
};
